export const EXTENSION_AUTH_TOKEN_COOKIE_NAME = "mem_extension_token";
export const EXTENSION_CLOSE_WINDOW_COOKIE_NAME = "mem_close_window_after_auth";
